import React from 'react';
import {
  FacebookShareButton,
  FacebookIcon,
  // TwitterIcon,
  TwitterShareButton,
  LinkedinIcon,
} from 'react-share';
import Twitter from "assets/twitter.png";

// overwrite the default twitter icon (now X)
// should update react-share, but it requires a higher react version
// updating react needs to be done across FE (common-fe, landing), otherwise the common-fe import will fail due to multiple react versions
const TwitterIcon = ({ size = 24 }) => {
  return <img alt="twitter" src={Twitter} style={{
    width: size,
    height: size,
  }} />;
};

const defaultTitle = 'Get another chance at credit without paying anything.';
const LINKED_IN_SHARE_URL = "https://www.linkedin.com/sharing/share-offsite/?url=";

const style = {
  padding: '0 8px',
  cursor: 'pointer',
  outline: 'none',
};

const SocialShares = ({
  url, className, size, hashtag, title = defaultTitle,
}) => (
  <div className={className}>
    <FacebookShareButton url={url} style={style} hashtag={hashtag}>
      <FacebookIcon
        size={size}
        borderRadius={8}
      />
    </FacebookShareButton>
    <TwitterShareButton url={url} title={title} style={style}>
      <TwitterIcon
        size={size}
        borderRadius={8}
      />
    </TwitterShareButton>
    <a
      href={`${LINKED_IN_SHARE_URL}${encodeURIComponent(url)}`}
      target="_blank"
      rel="noreferrer"
      className='px-2'
    >
      <LinkedinIcon
        size={size}
        borderRadius={8}
      />
    </a>

  </div>
);

SocialShares.defaultProps = {
  className: 'flex justify-center bg-primary',
  iconBgColor: '',
  logoColor: '',
  size: 32,
};

export default SocialShares;
